import { CloudArrowUp } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';

import { AttributeStatus } from 'companySettings/enums';
import { usePartFinderAttributeActions } from 'companySettings/hooks';
import { IPartFinderAttribute } from 'companySettings/types';
import { Button } from 'core/components';
import { NotificationPosition } from 'core/enums';
import { useAgGridClientTableContext } from 'core/states';
import { Color, Variant } from 'theme/enums';

// Publishes the drafts of the selected value lists; the ones already published have nothing
// to publish.
export const PublishPartFinderAttributesButton = () => {
  const { t } = useTranslation();

  const { selectedRows } = useAgGridClientTableContext();
  const { publishPartFinderAttributes } = usePartFinderAttributeActions(NotificationPosition.TOP);

  const unpublishedIds = ((selectedRows ?? []) as IPartFinderAttribute[])
    .filter((row) => AttributeStatus.PUBLISHED !== row.status)
    .map((row) => row.id);

  return (
    <Button
      text={t('buttonLabelPublish')}
      variant={Variant.SOFT}
      color={Color.PRIMARY}
      startDecorator={<CloudArrowUp />}
      disabled={!unpublishedIds.length}
      onClick={() => publishPartFinderAttributes(unpublishedIds)}
    />
  );
};
